import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormLabel, TextField, Autocomplete } from "@mui/material";

import { useCountryListing } from "../../../../../../../api/queries/network/useCountryListing";

import { EditEntityProfileData } from "../../../../../types/editEntityProfile-type";

const CountryField = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });
  const { control } = useFormContext<EditEntityProfileData>();
  const { countries, isCountriesDataLoading } = useCountryListing();

  return (
    <Controller
      name="countryId"
      control={control}
      render={({ field: { onChange, value, ...field }, fieldState: { error } }) => (
        <FormControl error={!!error} fullWidth>
          <FormLabel
            sx={{
              color: "var(--Dark---800, #414141)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "24px",
            }}
          >
            {t("country")}
          </FormLabel>
          <Autocomplete
            {...field}
            key={value}
            loading={isCountriesDataLoading}
            options={countries || []}
            value={countries?.find((country: any) => country.value == value) || null}
            getOptionLabel={(option: any) => option.label}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            disabled={!countries}
            onChange={(_, newValue: any | null) => {
              onChange(newValue ? newValue.value : null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={t("selectCountry")}
                error={!!error}
                helperText={error?.message && t(error.message)}
              />
            )}
          />
        </FormControl>
      )}
    />
  );
};

export default CountryField;
